(function ($, document, window, undefined) {

    'use strict'

    var Maps = function() {

        var map = null,
            styles = {
                default: null,
                custom: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#dadada"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 8
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ]
            }

        var initMap = function() {

            var mapPlaceholder = document.querySelector('[data-js=google-map]');

            var marker = document.querySelector('[data-js=marker]');

            console.log(  );

            map = new google.maps.Map(mapPlaceholder, {
                center: {lat: parseFloat( marker.getAttribute('data-lat') ), lng: parseFloat( marker.getAttribute('data-lng') ) },
                zoom: 14,
                mapTypeControl: false,
                styles: styles['custom']
            });
            
            // add a markers reference
            map.markers = [];

            // add markers
            addMapMarker( marker, map );
        }

        var addMapMarker = function( marker, map ) {

            // var
            var latlng = new google.maps.LatLng( marker.getAttribute('data-lat'), marker.getAttribute('data-lng') );
        
            // create marker
            var marker = new google.maps.Marker({
                position	: latlng,
                map			: map
            });
        
            // add to array
            map.markers.push( marker );
        
            // if marker contains HTML, add it to an infoWindow
            if( marker.innerHTML )
            {
                // create info window
                var infowindow = new google.maps.InfoWindow({
                    content		: marker.innerHTML
                });
        
                // show info window when marker is clicked
                google.maps.event.addListener(marker, 'click', function() {
        
                    infowindow.open( map, marker );
        
                });
            }
        
        }

        var init = function() {

            var script = document.createElement('script');

            script.onload = function() {
                window.Frontier.Maps.initMap();
            };

            script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDBWwmajVTkNh6EaSJ_rnQoM3kwSQeEuYQ&callback";
            document.getElementsByTagName('head')[0].appendChild(script);
        }

        return { init, initMap }
        
    }()

    if (!window.Frontier) window.Frontier = {};
        window.Frontier.Maps = Maps;

    }(jQuery, document, window));